import React from 'react';
import { useSelector } from 'react-redux';
import { parse, format } from 'date-fns';

import Accordion from 'components/Accordion';
import DatePicker from 'components/DatePicker';
import { store } from 'redux/store';
import {
  setDate,
  selectMWSeasonalForecastControlPanelDate,
} from 'redux/reducers/meteorologyWeatherSeasonalForecastControlPanelReducer';
import TitleSemiBold from 'components/Typography/TitleSemiBold';

export default function Dates() {
  const dateString = useSelector(selectMWSeasonalForecastControlPanelDate);
  const date = dateString ? parse(dateString, 'yyyyMMdd', new Date()) : null;

  function dispatchDate(newDate: Date | null) {
    const formattedDate = newDate ? format(newDate, 'yyyyMMdd') : undefined;
    store.dispatch(setDate(formattedDate));
  }

  return (
    <Accordion.Item eventKey="dates">
      <Accordion.Header>
        <TitleSemiBold>Data de rodada</TitleSemiBold>
      </Accordion.Header>
      <Accordion.Body>
        <DatePicker
          selected={date}
          onChange={(d) => dispatchDate(d)}
          maxDate={new Date()}
          inline
        />
      </Accordion.Body>
    </Accordion.Item>
  );
}
